import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=43ffe0df&"
import script from "./QuestionCard.vue?vue&type=script&lang=ts&"
export * from "./QuestionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports